import { render, staticRenderFns } from "./UserProfileSchoolData.vue?vue&type=template&id=6ee42094&"
import script from "./UserProfileSchoolData.vue?vue&type=script&lang=js&"
export * from "./UserProfileSchoolData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports